import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { Title, Form } from 'components/layout'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { injectIntl, FormattedMessage } from 'react-intl'

@form({
  form: 'award-set-major-warning-modal',
  disableHook: true
})
@injectIntl
class AwardSetMajorWarningModal extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    modalId: PropTypes.string,
    isLoading: PropTypes.bool,
    modal: PropTypes.func,
    onProceed: PropTypes.func.isRequired
  }

  render() {
    const {
      modalId,
      isLoading,
      modal,
      onProceed,
      handleSubmit
    } = this.props

    return (
      <Modal id={modalId} modal={modal} customActions>
        <Title h2 intlKey="title.confirmation">
          Confirmation
        </Title>
        <Form
          className="form"
          onSubmit={handleSubmit(onProceed)}
        >
          <div className="row">
            <div className="col-xs-12" style={{ marginBottom: '15px' }}>
              <FormattedMessage
                tagName="p"
                id="label.is_major_activity_confirmation"
                defaultMessage="The participant already has a major activity
                  on different award level. Do you want to add another one?"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6">
              <Button
                intlKey="button.dismiss"
                onClick={() => this.props.modal(null)}
                secondary
                type="button"
                style={{ marginRight: 10 }}
              >
                Dismiss
              </Button>
            </div>
            <div className="col-xs-6 text--right">
              <Button
                intlKey="button.continue"
                type="submit"
                isLoading={isLoading ? true : undefined}
              >
                Approve
              </Button>
            </div>
          </div>
        </Form>
      </Modal>
    )
  }
}

export default AwardSetMajorWarningModal
